module.exports = __webpack_public_path__ + "static/media/image-14.4a16cb62.jpg";